export type CostType = 'soft' | 'bill' | 'check';

// A firm's saved default cost type may predate the Check option, when only a two-way
// soft/hard choice existed. 'hard' meant exactly what 'bill' means today (BR-006).
export function resolveCostType(value?: string | null): CostType {
  if (value === 'hard') return 'bill';
  if (value === 'bill' || value === 'check') return value;
  return 'soft';
}
